import { Download, Loader2 } from "lucide-react";

// Two stacked components: a colored banner explaining the current gallery phase
// (proofing vs delivery), and a download bar that appears once delivered — gated by
// the optional download password.

export function PhaseBanner({ isDelivered, includedEdits, extraPrice }) {
  if (!isDelivered) {
    return (
      <div className="bg-amber-50 border border-amber-200 px-5 py-4 mb-8 text-sm" data-testid="gallery-phase-proofing">
        <div className="font-medium text-amber-900 mb-1">Step 1 · Pick your favorites for editing</div>
        <div className="text-amber-800">
          Tap the heart on the photos you'd like edited.{" "}
          {includedEdits > 0 && (
            <>
              Your package includes <strong>{includedEdits}</strong> complimentary edit{includedEdits > 1 ? "s" : ""};
              additional edits are <strong>${Number(extraPrice).toFixed(2)}</strong> each.
            </>
          )}{" "}
          You can leave a per-photo note (e.g. "crop tighter") by clicking the photo.
        </div>
      </div>
    );
  }
  return (
    <div className="bg-emerald-50 border border-emerald-200 px-5 py-4 mb-8 text-sm" data-testid="gallery-phase-delivery">
      <div className="font-medium text-emerald-900 mb-1">Your edited photos are ready</div>
      <div className="text-emerald-800">Use your download password to unlock high-res downloads.</div>
    </div>
  );
}

export function DownloadBar({
  requiresDlPw,
  downloadPassword,
  setDownloadPassword,
  onVerify,
  verifyingDl,
  zipping,
  onZip,
}) {
  return (
    <div className="mb-8" data-testid="gallery-download-bar">
      {requiresDlPw ? (
        <form onSubmit={onVerify} className="max-w-md mx-auto flex gap-2">
          <input
            type="password"
            value={downloadPassword}
            onChange={(e) => setDownloadPassword(e.target.value)}
            placeholder="Download password"
            className="flex-1 bg-transparent border border-stone-300 px-3 py-2 outline-none focus:border-stone-900"
            data-testid="download-password-input"
          />
          <button
            type="submit"
            disabled={!downloadPassword || verifyingDl}
            className="px-4 h-10 bg-stone-900 text-stone-50 text-xs uppercase tracking-[0.18em] hover:bg-stone-800 disabled:opacity-50"
            data-testid="unlock-downloads-btn"
          >
            {verifyingDl ? "…" : "Unlock"}
          </button>
        </form>
      ) : (
        <div className="text-center">
          <button
            onClick={onZip}
            disabled={zipping}
            className="inline-flex items-center gap-2 px-6 h-12 bg-stone-900 text-stone-50 text-xs uppercase tracking-[0.22em] hover:bg-stone-800 disabled:opacity-50"
            data-testid="download-all-btn"
          >
            {zipping ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
            {zipping ? "Preparing ZIP…" : "Download all (ZIP)"}
          </button>
          <p className="text-xs text-stone-500 mt-2">Or click any photo and download it individually.</p>
        </div>
      )}
    </div>
  );
}
